export const exportPdf = async (node, filename) => {
  const [{ default: html2canvas }, { jsPDF }] = await Promise.all([import("html2canvas"), import("jspdf")]);
  const canvas = await html2canvas(node, {
    scale: 2, backgroundColor: "#F3F5F7", useCORS: true, windowWidth: 1280,
    ignoreElements: (el) => el.dataset?.pdfIgnore === "true",
    onclone: (doc, el) => {
      el.style.width = "1100px";
      el.style.padding = "24px";
      const style = doc.createElement("style");
      style.textContent = "img{display:inline-block!important}";
      doc.head.appendChild(style);
    },
  });
  const pdf = new jsPDF({ orientation: "p", unit: "mm", format: "a4" });
  const margin = 8;
  const pageW = 210 - margin * 2;
  const pageH = 297 - margin * 2;
  const pxPerMm = canvas.width / pageW;
  const slicePx = Math.floor(pageH * pxPerMm);
  for (let y = 0, page = 0; y < canvas.height; y += slicePx, page += 1) {
    const h = Math.min(slicePx, canvas.height - y);
    if (page && h / pxPerMm < 8) break;
    const part = document.createElement("canvas");
    part.width = canvas.width;
    part.height = h;
    part.getContext("2d").drawImage(canvas, 0, y, canvas.width, h, 0, 0, canvas.width, h);
    if (page) pdf.addPage();
    pdf.addImage(part.toDataURL("image/jpeg", 0.92), "JPEG", margin, margin, pageW, h / pxPerMm);
  }
  pdf.save(filename);
};
